import React from 'react'
import { ICalculatorSubHeader } from '../../../../types'

const CalculatorSubHeader: React.FC<ICalculatorSubHeader> = ({text}) => {

  return (
    <>
      <div className='calculator__sub'>
          <span className='calculator__sub__text'>
            { text }  
          </span>
      </div>
    </>
  );
}

export default CalculatorSubHeader
